/* /home/szymon/kreator2/frontend/src/components/MailTriggersPanel.js */
// v6.0.0 – Dodano obsługę GET /admin/triggers/:id i relacji wiele-do-wielu,
//          naprawiono 404, zapisywanie i wczytywanie mailTemplateIds.

import React, { useState, useEffect } from "react";

export default function MailTriggersPanel({ backendUrl }) {
  const [triggers, setTriggers] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Form (dodawanie / edycja)
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  // Pola
  const [name, setName] = useState("");
  const [paramsText, setParamsText] = useState("{}");

  // multi-szablony: tablica id-ów
  const [allTemplates, setAllTemplates] = useState([]);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);

  useEffect(() => {
    fetchTriggers();
    fetchMailTemplates();
    // eslint-disable-next-line
  }, []);

  function fetchTriggers() {
    setLoading(true);
    fetch(`${backendUrl}/admin/triggers`, { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        setTriggers(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("[MailTriggersPanel] fetchTriggers =>", err);
        setError("Nie udało się pobrać listy triggerów.");
        setLoading(false);
      });
  }

  function fetchMailTemplates() {
    fetch(`${backendUrl}/admin/mailtemplates`, { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        setAllTemplates(data);
      })
      .catch((err) => {
        console.error("[MailTriggersPanel] fetchMailTemplates =>", err);
      });
  }

  // Nowy endpoint: GET /admin/triggers/:id – pobiera szczegóły 1 triggera + powiązane mailTemplateIds
  function fetchOneTrigger(id) {
    return fetch(`${backendUrl}/admin/triggers/${id}`, {
      credentials: "include",
    }).then((r) => {
      if (!r.ok) {
        throw new Error("Błąd pobierania pojedynczego triggera.");
      }
      return r.json();
    });
  }

  function handleAddClick() {
    setShowForm(true);
    setEditId(null);
    setName("");
    setParamsText("{}");
    setSelectedTemplateIds([]);
    setError("");
  }

  function handleEdit(t) {
    setError("");
    setShowForm(true);
    setEditId(t.id);
    setName(t.name);
    setLoading(true);

    // Parsujemy t.params => show in text area
    if (t.params) {
      setParamsText(JSON.stringify(t.params, null, 2));
    } else {
      setParamsText("{}");
    }

    // Pobierz dane z /admin/triggers/:id
    fetchOneTrigger(t.id)
      .then((triggerObj) => {
        setLoading(false);
        // Oczekujemy, że w JSON-ie jest "mailTemplateIds: number[]"
        if (Array.isArray(triggerObj.mailTemplateIds)) {
          setSelectedTemplateIds(triggerObj.mailTemplateIds);
        } else {
          setSelectedTemplateIds([]);
        }
      })
      .catch((err) => {
        console.error("[handleEdit] =>", err);
        setError(err.message);
        setLoading(false);
        setSelectedTemplateIds([]);
      });
  }

  function handleDelete(id) {
    if (!window.confirm("Na pewno usunąć trigger?")) return;
    setError("");
    setLoading(true);
    fetch(`${backendUrl}/admin/triggers/${id}`, {
      method: "DELETE",
      credentials: "include",
    })
      .then((r) => {
        if (!r.ok) throw new Error("Błąd usuwania triggera.");
        return r.json();
      })
      .then(() => {
        setLoading(false);
        fetchTriggers();
      })
      .catch((err) => {
        setLoading(false);
        setError(err.message);
      });
  }

  function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    let bodyParams = {};
    try {
      bodyParams = JSON.parse(paramsText);
    } catch (er) {
      setError("Niepoprawny JSON w polu Parametry.");
      setLoading(false);
      return;
    }

    const bodyObj = {
      name,
      params: bodyParams,
      mailTemplateIds: selectedTemplateIds,
    };

    const method = editId ? "PUT" : "POST";
    const url = editId
      ? `${backendUrl}/admin/triggers/${editId}`
      : `${backendUrl}/admin/triggers`;

    fetch(url, {
      method,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bodyObj),
    })
      .then((r) => {
        if (!r.ok) {
          throw new Error(
            editId
              ? "Błąd aktualizacji triggera."
              : "Błąd tworzenia triggera."
          );
        }
        return r.json();
      })
      .then(() => {
        setLoading(false);
        setShowForm(false);
        fetchTriggers();
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }

  // Toggle
  function toggleTemplate(tmplId) {
    if (selectedTemplateIds.includes(tmplId)) {
      setSelectedTemplateIds(selectedTemplateIds.filter((x) => x !== tmplId));
    } else {
      setSelectedTemplateIds([...selectedTemplateIds, tmplId]);
    }
  }

  function isSelected(tmplId) {
    return selectedTemplateIds.includes(tmplId);
  }

  function getToggleIcon(tmplId) {
    return isSelected(tmplId) ? "toggle_on" : "toggle_off";
  }
  // Zmieniamy kolor na zielony, gdy on
  function getToggleColor(tmplId) {
    return isSelected(tmplId) ? "green" : "#777";
  }

  return (
    <div className="orders-container" style={{ marginTop: "20px" }}>
      <h3>Trigger mail – Zarządzanie</h3>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p style={{ color: "#666" }}>Przetwarzanie...</p>}

      <button
        className="orders-add-btn"
        onClick={handleAddClick}
        style={{ marginBottom: 10 }}
      >
        {showForm ? "Anuluj" : "Dodaj nowy trigger"}
      </button>

      {showForm && (
        <form
          onSubmit={handleSubmit}
          className="orders-add-form"
          style={{ marginTop: "15px" }}
        >
          <div className="orders-form-group">
            <label>Nazwa triggera:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="orders-input"
              required
            />
          </div>

          {/* Lista szablonów */}
          <div className="orders-form-group">
            <label>Szablony:</label>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {allTemplates.map((tmpl) => {
                const iconName = getToggleIcon(tmpl.id);
                const iconColor = getToggleColor(tmpl.id);
                return (
                  <div
                    key={tmpl.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background: "#f9f9f9",
                      padding: "6px 10px",
                      borderRadius: 4,
                      cursor: "pointer",
                    }}
                    onClick={() => toggleTemplate(tmpl.id)}
                  >
                    <span
                      className="material-icons"
                      style={{ fontSize: 28, color: iconColor }}
                    >
                      {iconName}
                    </span>
                    <span style={{ marginLeft: 8 }}>{tmpl.name}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="orders-form-group">
            <label>Parametry (JSON):</label>
            <textarea
              value={paramsText}
              onChange={(e) => setParamsText(e.target.value)}
              rows={4}
              className="orders-input"
            />
          </div>

          <button type="submit" className="orders-button">
            Zapisz
          </button>
        </form>
      )}

      {triggers.length === 0 ? (
        <p style={{ marginTop: "15px" }}>Brak triggerów w bazie.</p>
      ) : (
        <table className="orders-table" style={{ marginTop: 15 }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nazwa</th>
              <th>Parametry</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {triggers.map((trg) => (
              <tr key={trg.id}>
                <td>{trg.id}</td>
                <td>{trg.name}</td>
                <td>
                  {trg.params && Object.keys(trg.params).length > 0 ? (
                    <pre style={{ maxWidth: 200, whiteSpace: "pre-wrap" }}>
                      {JSON.stringify(trg.params, null, 2)}
                    </pre>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  <button
                    onClick={() => handleEdit(trg)}
                    style={{ marginRight: 10 }}
                  >
                    Edytuj
                  </button>
                  <button onClick={() => handleDelete(trg.id)}>Usuń</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
